import Grid from "@mui/material/Grid";
import {Item} from "../CharStyled";
import {s_char_kv} from "../../_signals/s_char_defence";
import React from "react";
import {useSignals} from "@preact/signals-react/runtime";

export default function CharKV() {
    useSignals();
    return <Grid item sm={2} xs={4}>
        <Item>
            <div>Körperl.Vert:</div>
            {s_char_kv.value ?? '??'}
        </Item>
    </Grid>
}